import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import Spinner from '@atlaskit/spinner';
import { FormattedMessage } from '@atlassian/jira-intl';
import { StyledBox, StyledText } from '../../../../common/ui/picker/styled.tsx';
import messages from './messages.tsx';

export const LoadingMessage = () => (
	// eslint disabled because it is valid for options, see recommended https://github.com/jsx-eslint/eslint-plugin-jsx-a11y/blob/main/docs/rules/no-noninteractive-element-to-interactive-role.md
	// eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
	<Box as="li" xcss={listItemStyle} role="option" aria-selected={false}>
		<StyledBox data-testid="jql-builder-basic-picker.ui.async-select.menu-list.loading-message">
			<StyledBox height={72}>
				<Spinner size="large" />
			</StyledBox>
			<StyledText>
				<FormattedMessage {...messages.loadingMessage} />
			</StyledText>
		</StyledBox>
	</Box>
);
export default LoadingMessage;

const listItemStyle = xcss({
	listStyle: 'none',
});
